import React from 'react';
import AdminAnalyticsDashboard from './analytics/AdminAnalyticsDashboard';

/**
 * InternalAnalytics — Entry point for the admin analytics dashboard.
 *
 * Previously rendered a flat KPI card grid.
 * Now renders the full 9-tab AdminAnalyticsDashboard.
 *
 * Props:
 *   onBack — callback to return to the main dashboard view
 */
const InternalAnalytics = ({ onBack }) => {
    return <AdminAnalyticsDashboard onBack={onBack} />;
};

export default InternalAnalytics;
